module.exports = __webpack_public_path__ + "static/media/greenville-procurement-partners.a134e2f6.jpg";